import React from 'react';

const AnalyticsPanel = ({ analytics }) => {
  const stats = [
    {
      label: 'Profile Views',
      value: analytics?.profileViews || 0,
      change: analytics?.profileViewsChange || 0,
      badge: 'Views',
      gradientFrom: '#3B82F6',
      gradientTo: '#1E40AF'
    },
    {
      label: 'Reveal Requests',
      value: analytics?.revealRequests || 0,
      change: analytics?.revealRequestsChange || 0,
      badge: 'Requests',
      gradientFrom: '#06B6D4',
      gradientTo: '#0891B2'
    },
    {
      label: 'Approved Matches',
      value: analytics?.approvedMatches || 0,
      change: analytics?.approvedMatchesChange || 0,
      badge: 'Matches',
      gradientFrom: '#10B981',
      gradientTo: '#059669'
    },
    {
      label: 'Scheduled Interviews',
      value: analytics?.scheduledInterviews || 0,
      change: analytics?.scheduledInterviewsChange || 0,
      badge: 'Interviews',
      gradientFrom: '#F59E0B',
      gradientTo: '#D97706'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl border border-[#E5E7EB] p-6 hover:shadow-lg transition-all duration-250"
        >
          {/* Gradient Badge Title */}
          <div className="inline-block mb-4">
            <div
              className="px-4 py-1.5 rounded-md text-white text-sm font-semibold"
              style={{
                background: `linear-gradient(135deg, ${stat?.gradientFrom} 0%, ${stat?.gradientTo} 100%)`
              }}
            >
              {stat?.badge}
            </div>
          </div>

          {/* Main Content */}
          <div className="mb-4">
            <h3 className="text-2xl md:text-3xl font-bold text-[#111827] mb-2">
              {stat?.label}
            </h3>
            <p className="text-[#6B7280] text-sm leading-relaxed">
              Track your {stat?.label?.toLowerCase()} performance and engagement metrics.
            </p>
          </div>

          {/* Stats Row */}
          <div className="flex items-center justify-between pt-4 border-t border-[#E5E7EB]">
            <div>
              <p className="text-3xl font-bold text-[#111827]">{stat?.value}</p>
              <p className="text-xs text-[#9CA3AF] mt-1">Total count</p>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-1 justify-end">
                <span
                  className={`text-lg font-bold ${
                    stat?.change >= 0 ? 'text-[#10B981]' : 'text-[#EF4444]'
                  }`}
                >
                  {stat?.change >= 0 ? '+' : ''}{stat?.change}%
                </span>
              </div>
              <p className="text-xs text-[#9CA3AF] mt-1">vs last month</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsPanel;